import axios from "axios"

import { BaseURl } from '../../utils'

const getFreshToken = () => localStorage.getItem('token');

export const createUsera = async (data: any) => {
  try {
    const resoponse = await axios.post(`${BaseURl}User/create`, data)
    return resoponse
  } catch (error) {
    console.error(error)
    throw error;
  }
}

export const loginUser = async (data: any) => {
  const { values } = data
  try {
    const resoponse = await axios.post(`${BaseURl}User/login`, values)
    console.log(resoponse)
    return resoponse.data
  } catch (error) {
    console.error(error)
    throw error;
  }
}

export const getAlluser = async (data: any) => {
  const { currentPage, modeid, modeId, pageNo = 1, pageSize = 100 } = data;
  const freshlyFetchedToken = getFreshToken();
  const option = {
    headers: {
      'x-access-token': freshlyFetchedToken || ''
    }
  }
  try {
    // Support both parameter naming conventions
    const actualModeId = modeId || modeid;
    const actualPageNo = pageNo || currentPage || 1;
    const resoponse = await axios.get(`${BaseURl}User/getall/${actualModeId}?page_no=${actualPageNo}&page_size=${pageSize}`, option)
    return resoponse
  } catch (error) {
    console.error(error)
    throw error;
  }
}

// Get all users with proper pagination (for ShareModal)
export const getAllUsersApi = async (modeId: string, pageNo = 1, pageSize = 50) => {
  const freshlyFetchedToken = getFreshToken();
  const option = {
    headers: {
      'x-access-token': freshlyFetchedToken || ''
    }
  };
  try {
    const response = await axios.get(
      `${BaseURl}User/getall/${modeId}?page_no=${pageNo}&page_size=${pageSize}`,
      option
    );
    return response.data;
  } catch (error) {
    console.error('getAllUsersApi error:', error);
    throw error;
  }
};

export const getbyiduser = async (data: any) => {
  const freshlyFetchedToken = getFreshToken();
  const option = {
    headers: {
      'x-access-token': freshlyFetchedToken || ''
    }
  }
  try {
    const resoponse = await axios.get(`${BaseURl}User/getById/${data}`, option)
    return resoponse
  } catch (error) {
    console.error(error)
    throw error;
  }
}

export const deleteUser = async (id: any) => {
  const freshlyFetchedToken = getFreshToken();
  const option = {
    headers: {
      'x-access-token': freshlyFetchedToken || ''
    }
  }
  try {
    const resoponse = await axios.delete(`${BaseURl}User/remove/${id}`, option)
    return resoponse
  } catch (error) {
    console.error(error)
    throw error;
  }
}
export const updatestatus = async (data: any) => {
  const { editId, status } = data;
  const freshlyFetchedToken = getFreshToken();
  const options = {
    method: 'PUT',
    headers: {
      'content-type': 'application/json',
      'x-access-token': freshlyFetchedToken || '',
    },
    body: JSON.stringify({ status }),
  };
  try {
    const response: any = await fetch(
      `${BaseURl}User/update/${editId}`,
      options
    );
    return response.data; // Fixed the variable name here
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateUser = async ({ editId, values }: any) => {
  const freshlyFetchedToken = getFreshToken();
  try {
    const response = await fetch(`${BaseURl}User/update/${editId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': freshlyFetchedToken || '',
      },
      body: JSON.stringify(values),
    });

    const result = await response.json();
    if (!response.ok) throw new Error(result.message || 'Failed to update user');
    return result;
  } catch (err) {
    throw err;
  }
};

export const searchUser = async (name: any) => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const response = await fetch(
      `${BaseURl}User/filter?name=${name}`,
      options
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch data. Status: ${response.status}`);
    }

    const responseData = await response.json();

    return responseData; // Assuming the response is already JSON, no need to stringify.
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const searchUserbyAge = async (data: any) => {
  const { mode, gender, minAge, maxAge } = data;
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const response = await fetch(
      `${BaseURl}User/filter?mode=${mode}&gender=${gender}&minAge=${minAge}&maxAge=${maxAge}`,
      options
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch data. Status: ${response.status}`);
    }

    const responseData = await response.json();
    console.log(responseData)
    return responseData;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const sortUser = async (sort: any) => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }

  try {
    const response = await fetch(
      `${BaseURl}User/sort?sort_by_name=${sort}`,
      options
    );
    const responseData = await response.json();

    return responseData;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export const createProfile = async (data: any) => {
  const { avatarFil } = data;
  const freshlyFetchedToken = getFreshToken();

  const formData = new FormData();
  formData.append('image', avatarFil); // Assuming 'avatar' is the key for the file in the FormData
  const options = {
    method: 'PUT',
    headers: {
      // 'Content-Type': 'multipart/form-data',
      'x-access-token': freshlyFetchedToken || '',

    },


    body: formData
  };

  try {
    const response = await fetch(`${BaseURl}User/uploadMainProfile/${data.imageid}`, options);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const uploadGalleryImage = async (data: { id: string; avatarFil: File }) => {
  const { id, avatarFil } = data;
  const freshlyFetchedToken = getFreshToken();

  if (!avatarFil) {
    return { isSuccess: false, message: "No file provided" };
  }

  const formData = new FormData();
  formData.append("image", avatarFil); // 👈 MUST MATCH SWAGGER

  console.log("⬆ FILE UPLOAD PAYLOAD", Object.fromEntries(formData.entries()));

  try {
    const response = await fetch(`${BaseURl}User/uploadProfile/${id}`, {
      method: "PUT", // ✔ Same as Swagger
      headers: {
        "x-access-token": freshlyFetchedToken || '', // remove ! if optional
        // ❗ DO NOT set Content-Type
      },
      body: formData,
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Upload failed");
    }

    return await response.json();
  } catch (error) {
    console.error("Upload error:", error);
    throw error;
  }
};


export const RemoveImageintoGallery = async (data: any) => {
  const { id, item } = data
  const freshlyFetchedToken = getFreshToken();
  console.log(id, item);

  const options = {
    method: 'DELETE',
    headers: {

      'x-access-token': freshlyFetchedToken || '',

    },



  };


  try {
    const response = await fetch(`${BaseURl}User/${id}/remove-avatar/${item}`, options);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const changePasswordUser = async (data: any) => {
  const { id, oldPassword, newPassword } = data;
  const freshlyFetchedToken = getFreshToken();
  try {
    const response = await fetch(`${BaseURl}User/changePassword/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': freshlyFetchedToken || '',
      },
      body: JSON.stringify({ oldPassword, newPassword }), // 👈 IMPORTANT FIX
    });

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || 'Failed to change password');
    }

    return result; // {isSuccess, message, ...}
  } catch (error) {
    console.error(error);
    throw error;
  }
};
